import type { SaveSurveyMenuOption } from '../models/save-survey-menu-option.model';

export const DEFAULT_SAVE_SURVEY_LABEL = 'Save Project';

export const SAVE_SURVEY_MENU_OPTIONS: readonly SaveSurveyMenuOption[] = [
  { id: 'save', label: 'Save', default: true },
  { id: 'save-and-clone', label: 'Save and Clone', default: true },
  { id: 'save-and-create-new', label: 'Save and Create New', default: true },
  { id: 'save-as-new-template', label: 'Save as New Template', default: true },
  {
    id: 'update-the-current-template',
    label: 'Update the Current Template',
    default: false,
  },
];

export const DEFAULT_SAVE_SURVEY_MENU_OPTIONS: readonly SaveSurveyMenuOption[] =
  SAVE_SURVEY_MENU_OPTIONS.filter((option) => option.default);
